import { render, staticRenderFns } from "./ProductManage.vue?vue&type=template&id=074b2f65&scoped=true&"
import script from "./ProductManage.vue?vue&type=script&lang=js&"
export * from "./ProductManage.vue?vue&type=script&lang=js&"
import style0 from "./ProductManage.vue?vue&type=style&index=0&id=074b2f65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074b2f65",
  null
  
)

export default component.exports